import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@vision/ui/store';

export const plannerRootSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ plannerId, plannerBoards, selectedBoardId, tasks }) => ({
    plannerId,
    plannerBoards,
    selectedBoardId,
    tasks,
  }),
);

export const plannerBoardsSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ plannerBoards, selectedBoardId }) => ({
    plannerBoards,
    selectedBoardId,
  }),
);

export const plannerTaskDrawerSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({
    plannerTaskDrawerOpened,
    selectedBoardId,
    selectedTaskStatus,
    plannerId,
    editingTask,
    attachmentsToUpload,
    taskRelationToAdd,
  }) => ({
    opened: plannerTaskDrawerOpened,
    selectedBoardId,
    selectedTaskStatus,
    plannerId,
    editingTask,
    attachmentsToUpload,
    taskRelationToAdd,
  }),
);

export const plannerBoardModalSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ plannerBoardModalOpened, plannerBoardModalMode, plannerId }) => ({
    plannerId,
    opened: plannerBoardModalOpened,
    mode: plannerBoardModalMode,
  }),
);

export const selectedBoardSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ selectedBoardId, plannerBoards }) => {
    return plannerBoards.find((board) => board.id === selectedBoardId);
  },
);

export const columnSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ tasksLoaded }) => {
    return { tasksLoaded };
  },
);

export const plannerCommentSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ editingTask, selectedBoardId, plannerId }) => {
    return { taskId: editingTask?.id, dashboardId: selectedBoardId, plannerId };
  },
);

export const plannerAttachmentSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ editingTask, selectedBoardId, plannerId }) => {
    return { taskId: editingTask?.id, dashboardId: selectedBoardId, plannerId };
  },
);

export const plannerAttachmentsAreaSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ attachmentsToUpload, editingTask, plannerId, selectedBoardId, comments }) => {
    return { attachmentsToUpload, editingTask, plannerId, dashboardId: selectedBoardId, comments };
  },
);

export const plannerCommentInputSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ editingTask, selectedBoardId, plannerId }) => {
    return { taskId: editingTask?.id, dashboardId: selectedBoardId, plannerId };
  },
);

export const plannerCommentsAreaSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ comments, editingTask, selectedBoardId, plannerId }) => ({
    comments,
    editingTask,
    selectedBoardId,
    plannerId,
  }),
);

export const plannerLabelsSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ plannerId, selectedBoardId, labels, editingTask }) => ({
    plannerId,
    dashboardId: selectedBoardId,
    labels,
    editingTask,
  }),
);

export const plannerTaskCardSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ selectedBoardId }) => ({
    selectedBoardId,
  }),
);

export const plannerWatchersSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ selectedBoardId, plannerId, editingTask }) => ({
    dashboardId: selectedBoardId,
    plannerId,
    editingTask,
  }),
);

export const plannerTaskRelationModalSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ plannerId, taskRelationToAdd }) => ({
    plannerId,
    taskRelationToAdd,
  }),
);

export const plannerRelatedEntitiesAreaSelector = createSelector(
  (state: RootState) => state.PlannerState,
  ({ editingTask, plannerId, selectedBoardId, taskRelationToAdd }) => ({
    taskId: editingTask?.id,
    taskRelations: editingTask?.task_relations || [],
    plannerId,
    dashboardId: selectedBoardId,
    taskRelationToAdd,
  }),
);
